import "./ach_management.scss";

let achManagementComponent = {
  restrict: "E",
  bindings: {},
};

export default achManagementComponent;



// WEBPACK FOOTER //
// ./client/app/components/ach_management/ach_management.component.js